import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { useI18n } from '@change-corgi/core/react/i18n';

import { Waypoint } from 'src/app/shared/components/scroll';

import { DmCards } from './components/DmCards';
import { DmOverview } from './components/DmOverview';
import { useDecisionMakersList } from './hooks/useDecisionMakersList';

export const DecisionMakersList: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { petitionEditPage, dmSources, decisionMakers },
		actions: { trackAddOrEditDmsClick, trackView },
	} = useDecisionMakersList();

	const decisionMakersAvailable = decisionMakers.length > 0;

	return (
		<div data-testid="decision-makers-list" data-qa="decision-makers-list" className="bg-white">
			<Waypoint onEnter={() => trackView()} />

			<div className="flex h-full flex-col gap-6 p-4 py-8 md:p-12 md:pt-8 lg:py-12">
				<DmOverview dmSources={dmSources} />

				<DmCards />

				<div
					className={cn('flex', { 'flex-row-reverse': decisionMakersAvailable, 'flex-row': !decisionMakersAvailable })}
				>
					<Button
						as="a"
						data-qa="edit-decision-makers-button"
						variant={decisionMakersAvailable ? 'secondary' : 'primary'}
						href={petitionEditPage}
						onClick={trackAddOrEditDmsClick}
						size="small"
						className="w-full md:w-auto"
					>
						{decisionMakersAvailable
							? translate('corgi.petition.starter_dashboard_v2.decision_makers.edit_button')
							: translate('corgi.petition.starter_dashboard_v2.decision_makers.add_button')}
					</Button>
				</div>
			</div>
		</div>
	);
};
